import React from 'react'

const Input = ({
    className,
    type,
    value,
    name,
    id,
    placeHolder,
    handleChange,
    error
}) => {
    return (
        <>
            <input
                required
                type={type}
                name={name}
                value={value}
                className={`form-control p-0 ${className} ${error && "border-danger bg-error"
                    }`}
                placeholder={placeHolder}
                onChange={handleChange}
            />
        </>
    )
}

export default Input

